"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  vertical-align: ", ";\n  \n  &, > span {\n    display: inline-block;\n    font-size: ", ";\n  }\n  \n  > span {\n    font-family: arena-icons;\n    height: 1em;\n    line-height: 1;\n    vertical-align: top;\n  }\n"], ["\n  height: ", ";\n  vertical-align: ", ";\n  \n  &, > span {\n    display: inline-block;\n    font-size: ", ";\n  }\n  \n  > span {\n    font-family: arena-icons;\n    height: 1em;\n    line-height: 1;\n    vertical-align: top;\n  }\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iconUnicode = require("../../utils/iconUnicode");

var _iconUnicode2 = _interopRequireDefault(_iconUnicode);

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledIcon = _styledComponents2.default.div(_templateObject, function (props) {
  return c.px(props.size);
}, function (props) {
  return props.verticalAlign;
}, function (props) {
  return c.px(props.size);
});

var Icon = function Icon(props) {
  return _react2.default.createElement(StyledIcon, {
    size: props.fontSize,
    style: props.style,
    thick: props.thick,
    thin: props.thin,
    verticalAlign: props.verticalAlign
  }, (0, _iconUnicode2.default)({
    thick: props.thick,
    thin: props.thin,
    type: props.type
  }));
};

Icon.defaultProps = _propTypes.iconDefaultProps;
Icon.propTypes = _propTypes.iconPropTypes;
exports.default = Icon;